import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import * as AirlinelistActions from './Airlinelist.action';
import { NSAdminbuysellRuleserviceService } from '../../Clients/NS/Services/NSAdminbuysellRuleservice.service';

@Injectable()
export class AirlinelistEffects {
  loadAirlines$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AirlinelistActions.loadAirlines),
      mergeMap(() =>
        this.airlineService.GetAirlinlist().pipe(
          map((response) => {
            const airlines = response.map((item: any) => ({
              Disabled: false,
              Group: null,
              Selected: false,
              text: item.airlineName + '(' + item.airlineCode + ')',
              value: item.airlineCode,
            }));
            return AirlinelistActions.loadAirlinesSuccess({ airlines });
          }),
          catchError((error) =>
            of(AirlinelistActions.loadAirlinesFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private airlineService: NSAdminbuysellRuleserviceService
  ) {}
}
